import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-field-display',
  templateUrl: './field-display.component.html',
  styleUrls: ['./field-display.component.scss']
})
export class FieldDisplayComponent implements OnInit {
    @Input() name = '';
    @Input() value = '';
    @Input() currency = false;
    @Input() enabledClick = false;

    @Output() click = new EventEmitter<void>();

    fieldWidth = 30;
    valueWidth = 70;

    constructor() { }

    ngOnInit(): void {
        if(this.currency){
            this.valueWidth = 60;
            this.fieldWidth = 40;
        }
    }

    async clicked(){
        if(this.enabledClick){
            this.click.emit();
        }
    }

}
